/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */

export type ResizePlatform = typeof ResizePlatform[keyof typeof ResizePlatform];


export const ResizePlatform = {
  meta: 'meta',
  tiktok: 'tiktok',
  google: 'google',
  youtube: 'youtube',
  x: 'x',
  pinterest: 'pinterest',
  snapchat: 'snapchat',
  linkedin: 'linkedin',
} as const;
